import React, { useMemo, useContext } from 'react'
import { formatOccupantsAsGuests } from 'lib/offer/occupancyUtils'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'

interface Props {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const FlightSearchTravellerSelectField = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { className, onClick, disabled } = props
  const state = useContext(FlightSearchWidgetStateContext)

  const { occupants } = state

  const fieldValue = useMemo(() => formatOccupantsAsGuests(occupants), [occupants])

  const isValid = useMemo(() => occupants.childrenAge?.every(age => age !== -1), [occupants])

  return (<SearchFormField
    disabled={!!disabled}
    className={className}
    label="Travellers"
    required
    requiredErrorMessage="Please select children's ages"
    value={isValid ? fieldValue : undefined}
    onClick={disabled ? undefined : onClick}
    ref={ref}
  />
  )
})

FlightSearchTravellerSelectField.displayName = 'FlightSearchTravellerSelectField'

export default FlightSearchTravellerSelectField
